import { OFFER_SCORE_CHART_STYLES } from './constants';

export const getStickLocationPadding = (size: 'sm' | 'md' | 'lg') => {
  const styles = OFFER_SCORE_CHART_STYLES[size];
  const halfStickHeight = Number(styles.stick.height.replace('px', '')) / 2;

  const halfStickWidth = Number(styles.stick.width.replace('px', '')) / 2;

  const halfLineThickness = Number(styles.mask.left.replace('px', '')) / 2;

  const bottomPadding = halfStickHeight + halfLineThickness;
  const leftPadding = halfStickWidth - halfLineThickness;

  return { bottomPadding, leftPadding };
};
